import React, { useEffect, useState } from 'react';
import { api } from '../../helpers/api';
import { Spinner } from 'reactstrap';

interface AuthImageProps {
  src: string; // "uploads/waybills/photo.jpg"
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

const AuthImage: React.FC<AuthImageProps> = ({ src, alt, className, style, onClick }) => {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let objectUrl: string | null = null;
    let cancelled = false;

    const loadImage = async () => {
      try {
        const response = await api.get(`/${src}`, { responseType: 'blob' });
        if (!cancelled) {
          objectUrl = URL.createObjectURL(response.data);
          setBlobUrl(objectUrl);
        }
      } catch {
        if (!cancelled) setError(true);
      }
    };

    if (src) loadImage();

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [src]);

  if (error) {
    return (
      <div
        className={className}
        style={{ ...style, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5' }}
      >
        <i className="ri-image-line text-muted fs-24" />
      </div>
    );
  }

  if (!blobUrl) {
    return (
      <div
        className={className}
        style={{ ...style, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Spinner size="sm" color="secondary" />
      </div>
    );
  }

  return <img src={blobUrl} alt={alt || ''} className={className} style={style} onClick={onClick} />;
};

export default AuthImage;

/** Dosyayı yeni sekmede aç (JWT ile) */
export const openAuthFile = async (filePath: string) => {
  try {
    const response = await api.get(`/${filePath}`, { responseType: 'blob' });
    const blobUrl = URL.createObjectURL(response.data);
    window.open(blobUrl, '_blank');
  } catch {
    console.error('Dosya açılamadı');
  }
};
